import { Component, OnInit } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { UserManageInfo } from '../models/userManageInfo';
import { AdminService } from '../services/admin.service';
import { Client } from '../models/client';
import { Implant } from '../models/implant';
import { ImpiantoService } from '../services/impianto.service';

@Component({
  selector: 'app-profile-page',
  templateUrl: './profile-page.component.html',
  styleUrls: ['./profile-page.component.css']
})
export class ProfilePageComponent implements OnInit {

  public userInfo: UserManageInfo;
  public client: Client = null
  public implant: Implant = null

  constructor(private authService: AuthService, private adminService: AdminService, private impiantoService: ImpiantoService) { }

  private getUserInfo() {
    this.authService.getManageInfo().subscribe(result => {
      if (result != null) {
        this.userInfo = result;
        this.getCurrentUserInfo();
      }
    });
  }

  private getCurrentUserInfo() {
    if (this.userInfo.Ruolo == "Admin" || this.userInfo.Ruolo == "SuperAdmin") {

    } else if (this.userInfo.Ruolo == "Cliente") {
      this.adminService.getConnectedClientInfo().subscribe(result => {
        this.client = result;
        console.log(this.client)
      });
    } else if (this.userInfo.Ruolo == "Impianto") {
      this.impiantoService.getConnectedImplantInfo().subscribe(result => {
        this.implant = result;
        console.log(this.implant)
      });
    }
  }

  ngOnInit() {
    this.getUserInfo();
  }
}



// WEBPACK FOOTER //
// ./src/app/profile-page/profile-page.component.ts